import { ReactComponent as FailedIcon } from 'assets/icons/FailedIcon.svg';
import { ReactComponent as SucessIcon } from 'assets/icons/SucessIcon.svg';
import { useMobileView } from 'hook/mobileView/useMobileView';
import React from 'react';
import { ButtonWrapper, CardContent, Title, Wrapper } from './Theme';
export const PaymentResultPage = ({ result, formik, setTotalForPay, setChecked, setChargeSelections }) => {
    const { isMobile } = useMobileView()

    const lastCardNum = formik?.values?.cardsDetails?.card_number?.slice(-4)
    const handleCancel = () => {
        setTotalForPay(0)
        setChecked([])
        formik.setFieldValue('resultPage', '')
        formik.setFieldValue('accountInfo', {});
        formik.setFieldValue('cardsDetails', {});
        setChargeSelections([])
    }
    return (
        <Wrapper>
            <CardContent isMobile={isMobile}>
                {result === 'success' ?
                    <div>
                        <SucessIcon />
                        <Title isMobile={isMobile}>Payment Succeeded!</Title>
                        <p>Thank you! Your payment has been processed successfully.</p>
                        <ButtonWrapper>
                            <button onClick={handleCancel}>Done</button>
                        </ButtonWrapper>
                    </div>
                    :
                    <div><FailedIcon />
                        <Title isMobile={isMobile}>Payment Failed!</Title>
                        <p>Unfortunately we were unable to charge your payment ending in {lastCardNum}.
                            Please try again to continue.</p>
                        <ButtonWrapper>
                            <button onClick={() => formik.setFieldValue('resultPage', '')}>Try Again</button>
                            <button onClick={handleCancel}>Cancel</button>
                        </ButtonWrapper>
                    </div>}
            </CardContent>
        </Wrapper>
    );
};
